import React, { useState } from "react";
import CustomerSelection from "./CustomerSelection";
import PaymentProcess from "./PaymentProcess";
import { CustomerData, ProductDetail } from "../../../../../shared/services/interface";
import { Product } from "../NotesProducts";

type Props = {
  selectProductList: Product[] | any[];
  discount: { discountedAmount: string; discountValue: string; mode: string };
  upDateCustomer: (data: CustomerData | any) => void;
  receivedAmount: (data: number, paymentMethod: string) => void;
  clearData: string;
  throwStatus: (status: string) => void;
  finalAmount: number;
  resvedAmount?: number;           // Add this prop
  setResvedAmount?: (data: number) => void;  // Add this prop
  deliveryFee?: number;
  parcelFee?: number;
  deliveryFeeEnabled?: boolean;
  parcelFeeEnabled?: boolean;
  setDeliveryFee?: React.Dispatch<React.SetStateAction<number>>;
  setParcelFee?: React.Dispatch<React.SetStateAction<number>>;
  onSplitChange?: (splits: { method: string; amount: number }[]) => void;
  onIncludeOldBalanceChange?: (value: boolean) => void;
};

function SidePanel({
  selectProductList,
  discount,
  upDateCustomer,
  receivedAmount,
  clearData,
  throwStatus,
  finalAmount,
  resvedAmount,        // Receive from parent
  setResvedAmount,      // Receive from parent
  deliveryFee,
  parcelFee,
  deliveryFeeEnabled,
  parcelFeeEnabled,
  setDeliveryFee,
  setParcelFee,
  onSplitChange,
  onIncludeOldBalanceChange,
}: Props) {
  const [customerDetail, setCustomerDetail] = useState<CustomerData | any>(clearData);

  return (
    <div className='w-full h-full p-1 bg-gray-100 rounded-lg shadow-inner border border-gray-100 flex flex-col gap-2 overflow-auto'>
      <CustomerSelection
        customerDetails={(data) => {
          setCustomerDetail(data);
          upDateCustomer(data);
        }}
        clearData={clearData}
        selectProductList={selectProductList}
      />
      <PaymentProcess
        finalAmount={finalAmount}
        customerDetail={customerDetail}
        selectProductList={selectProductList}
        discount={discount}
        receivedAmount={(data, paymentMethod) => receivedAmount(data, paymentMethod)}
        clearData={clearData}
        throwStatus={(status: string) => throwStatus(status)}
        resvedAmount={resvedAmount}           // Pass to PaymentProcess
        setResvedAmount={setResvedAmount}     // Pass to PaymentProcess
        deliveryFee={deliveryFee}
        parcelFee={parcelFee}
        deliveryFeeEnabled={deliveryFeeEnabled}
        parcelFeeEnabled={parcelFeeEnabled}
        onDeliveryFeeChange={setDeliveryFee}
        onParcelFeeChange={setParcelFee}
        onSplitChange={onSplitChange}
        onIncludeOldBalanceChange={onIncludeOldBalanceChange}
      />
    </div>
  );
}

export default SidePanel;